module.exports = __webpack_public_path__ + "static/img/Resurfacing-h-200.e2f2099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Resurfacing-h-200.png
// module id = ngIi
// module chunks = 7